// extracted by mini-css-extract-plugin
module.exports = {"nameButton":"kl2Hr"};